<!--
 * @FileDescription: 
 * @version: 2.0
 * @Author: 胡明浩
 * @Date: 2021-06-11 16:19:25
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-09-13 09:35:18
-->
<template>
  <e-Dialog
    :dialog-title="invoiceTitle"
    :center-dialog-visible="dialogFormVisible"
    :popup-width="'800px'"
    button-tip="保存"
    @resetPopupData="setResetPopupData"
    @submitPopupData="setSubmitPopupData"
  >
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="140px"
      class="demo-ruleForm"
    >
      <!-- <el-row>
        <el-col :span="18" :offset="2">
          <el-form-item label="发票类型：" prop="invoiceType">
            <el-radio-group
              v-model="ruleForm.invoiceType"
              style="margin-top:6px"
            >
              <el-radio :label="'101'">增值税普通发票</el-radio>
              <el-radio :label="'102'">增值税专用发票</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="18" :offset="2">
          <el-form-item label="发票抬头：" prop="title">
            <el-input
              v-model="ruleForm.title"
              maxlength="100"
              placeholder="请输入发票抬头"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18" :offset="2">
          <el-form-item label="纳税人识别号：" prop="identificationNumber">
            <el-input
              v-model="ruleForm.identificationNumber"
              maxlength="100"
              placeholder="请输入纳税人识别号"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.invoiceType != '101'">
        <el-col :span="18" :offset="2">
          <el-form-item label="注册地址：" prop="address">
            <el-input
              v-model="ruleForm.address"
              maxlength="100"
              placeholder="请输入注册地址"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.invoiceType != '101'">
        <el-col :span="18" :offset="2">
          <el-form-item label="注册电话：" prop="telephone">
            <el-input
              v-model="ruleForm.telephone"
              maxlength="255"
              placeholder="请输入注册电话"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.invoiceType != '101'">
        <el-col :span="18" :offset="2">
          <el-form-item label="开户银行：" prop="bank">
            <el-input
              v-model="ruleForm.bank"
              maxlength="50"
              placeholder="请输入开户银行"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.invoiceType != '101'">
        <el-col :span="18" :offset="2">
          <el-form-item label="银行账号：" prop="bankAccount">
            <el-input
              v-model="ruleForm.bankAccount"
              maxlength="50"
              placeholder="请输入银行账号"
              @keyup.native="
                ruleForm.bankAccount = ruleForm.bankAccount.replace(
                  /[^\d-]/g,
                  ''
                )
              "
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18" :offset="2">
          <el-form-item>
            <el-checkbox v-model="isDefault" label="设为默认发票"></el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- <div class="foot">
      <div class="back" @click="close">返回</div>
      <div class="invoice-handle" @click="submitForm('ruleForm')">
        使用此发票
      </div>
    </div> -->
  </e-Dialog>
</template>

<script>
import api from '../../../../api/evaluation/index';
import eDialog from '../../../../../../components/common/e-dialog.vue';

export default {
  components: {
    eDialog,
  },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false,
    },
    invoiceTitle: {
      type: String,
      default: '添加发票信息',
    },
    // 反显数据
    details: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    const title = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入发票抬头'));
      } else {
        callback();
      }
    };
    const identificationNumber = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入纳税人识别号'));
      } else {
        callback();
      }
    };
    const phoneReg = /^0?(11|12|13|15|16|17|18|19|14)[0-9]{9}$/;
    const telReg = /^((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/;
    const telephone = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入注册电话'));
      } else if (!phoneReg.test(value) && !telReg.test(value)) {
        callback(new Error('请输入正确的电话号码'));
      } else {
        callback();
      }
    };
    return {
      replaceData: {},
      isDefault: false,
      regionArray: [
        {
          code: '101',
          desc: '增值税普通发票',
        },
        {
          code: '102',
          desc: '增值税专用发票',
        },
      ],
      ruleForm: {
        invoiceType: '102', // 发票类型
        title: '', // 发票抬头
        identificationNumber: '', // 纳税人识别号
        address: '', // 注册地址
        telephone: '', // 电话
        bank: '', // 开户银行
        bankAccount: '', // 银行账号
        isShare: 2,
      },
      rules: {
        invoiceType: [
          {
            required: true,
            message: '请选择发票类型',
            trigger: 'change',
          },
        ],
        title: [
          {
            required: true,
            validator: title,
            trigger: 'blur',
          },
        ],
        identificationNumber: [
          {
            required: true,
            validator: identificationNumber,
            trigger: 'blur',
          },
        ],
        address: [
          {
            required: true,
            message: '请输入注册地址',
            trigger: 'blur',
          },
        ],
        telephone: [
          {
            required: true,
            validator: telephone,
            trigger: 'blur',
          },
        ],
        bank: [
          {
            required: true,
            message: '请输入开户银行',
            trigger: 'blur',
          },
        ],
        bankAccount: [
          {
            required: true,
            message: '请输入银行账号',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  watch: {
    details(newVal) {
      this.replaceData = newVal;
      if (Object.keys(newVal).length) {
        this.ruleForm.invoiceType = newVal.invoiceType; // 发票类型
        this.ruleForm.title = newVal.title; // 发票抬头
        this.ruleForm.identificationNumber = newVal.identificationNumber; // 纳税人识别号
        this.ruleForm.address = newVal.address; // 注册地址
        this.ruleForm.telephone = newVal.telephone; // 电话
        this.ruleForm.bank = newVal.bank; // 开户银行
        this.ruleForm.bankAccount = newVal.bankAccount; // 银行账号
        // this.ruleForm.companyName = newVal.invoiceId;
        this.isDefault = newVal.isDefault !== 0;
        this.ruleForm.invoiceId = newVal.invoiceId;
      }
    },
  },
  methods: {
    // 编辑时获取发票信息
    async getInvoiceDetail() {},
    setSubmitPopupData() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.saveAndUpdateInvoiceManage();
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName('is-error');
            isError[0].querySelector('input').focus();
          }, 100);
          return false;
        }
      });
    },
    setResetPopupData() {
      this.resetForm('ruleForm');
      this.$emit('resetPopupData');
    },
    close() {
      this.resetForm('ruleForm');
      this.$emit('close');
      this.$refs.ruleForm.resetFields();
      Object.keys(this.ruleForm).forEach((item) => {
        this.ruleForm[item] = '';
      });
      this.isDefault = false;
    },
    // 改变发票类型清空数据
    changeinvoiceType() {
      Object.keys(this.ruleForm).forEach((item) => {
        if (item != 'invoiceType') {
          this.ruleForm[item] = '';
        }
      });
      this.isDefault = false;
    },
    resetForm(formName) {
      (this.ruleForm = {
        invoiceType: '102', // 发票类型
        title: '', // 发票抬头
        identificationNumber: '', // 纳税人识别号
        address: '', // 注册地址
        telephone: '', // 电话
        bank: '', // 开户银行
        bankAccount: '', // 银行账号
        isShare: 2,
      }),
        this.$refs[formName].resetFields();
    },
    async saveAndUpdateInvoiceManage() {
      let res = {};
      if (this.invoiceTitle === '添加发票信息') {
        res = await api.addInvoice({
          ...this.ruleForm,
          isDefault: this.isDefault ? 1 : 0,
        });
      } else {
        res = await api.modifyInvoice({
          ...this.ruleForm,
          isDefault: this.isDefault ? 1 : 0,
        });
      }

      if (res.code === '200') {
        this.resetForm('ruleForm');
        this.$emit('submitPopupData');
      }
      // if (res.success) {
      //   this.close();
      //   this.$parent.showInvoiceMask = false;
      //   this.$parent.getQueryUserInvoice();
      //   this.$message({
      //     message: '发票信息操作成功',
      //     type: 'success',
      //     duration: 5000,
      //   });
      //   if (this.title == '新增发票') {
      //     this.$parent.invoiceHandleFlag = true;
      //   } else {
      //     this.$parent.invoiceHandleFlag = false;
      //     this.$parent.activeInvoeicItem = this.replaceData;
      //   }
      // }
    },
    // 保存
    // submitForm(formName, steps) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       this.saveAndUpdateInvoiceManage();
    //     } else {
    //       setTimeout(() => {
    //         const isError = document.getElementsByClassName('is-error');
    //         isError[0].querySelector('input').focus();
    //       }, 100);
    //       return false;
    //     }
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';

::v-deep .el-input__inner {
  border-radius: 0;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
}
.el-form-item {
  margin-bottom: 20px;
}
.form-item {
  width: 100%;
}
.foot {
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
  .back {
    width: 90px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: 1px solid #d9d9d9;
    color: #333;
    cursor: pointer;
    &:hover {
      border: 1px solid #2587ff;
      color: #2587ff;
    }
  }
  .invoice-handle {
    margin-left: 20px;
    width: 90px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #2587ff;
    color: #fff;
    cursor: pointer;
    &:hover {
      background-color: #126edf;
    }
  }
}
::v-deep .el-dialog__headerbtn {
  top: 12px;
}
::v-deep .el-dialog__headerbtn:hover {
  .el-dialog__close {
    color: $main-col;
  }
}
::v-deep .el-dialog--center {
  text-align: start;
}
::v-deep .el-dialog__header {
  padding: 10px 20px;
  background: #ededed;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .el-dialog__title {
    font-size: 14px;
    color: #333;
    line-height: 14px;
  }
}
::v-deep .el-checkbox__input {
  padding-bottom: 2px;
}
::v-deep .el-dialog__headerbtn {
  right: 18px;
}
::v-deep .el-dialog__body {
  padding: 27px 20px 0px 20px;
  .el-checkbox__input .el-checkbox__inner {
    border-color: #dcdfe6;
    &:hover {
      border-color: $main-col;
    }
  }

  .el-checkbox__input.is-checked.is-focus .el-checkbox__inner {
    border-color: $main-col;
  }
  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #dcdfe6;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background: $main-col;
    border-color: $main-col;
  }
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background: $main-col;
    border-color: $main-col;
    &::before {
      background-color: $c3;
    }
  }
  ::v-deep .selected {
    font-weight: normal !important;
  }
  .el-checkbox__label {
    line-height: 14px;
    color: #333333;
  }
  .save {
    font-size: 14px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: $cf;
    background-color: $main-col;
    border-color: $main-col;
    width: 200px;
    height: 40px;
    border-radius: 0px;
    margin-bottom: 20px;
    &:hover {
      background-color: $main-hover;
      border-color: $main-hover;
    }
  }
}
</style>
